
import { defineComponent, inject } from 'vue';
import { useVModel } from 'vue-composable';
import { InjectionKeys } from '@/constants';
import Label from '@/components/form-controls/base/Label.vue';

export default defineComponent({
  name: 'BaseInput',
  emits: ['update:modelValue'],
  components: {
    Label
  },
  props: {
    modelValue: {
      type: [String, Number]
    }
  },
  setup(props) {
    const setDirty = inject(InjectionKeys.SetFormDirty);
    const state = useVModel(props, 'modelValue');

    return {
      setDirty,
      state
    };
  }
});
